import React, { useEffect, useState } from 'react';

import * as env from 'config/environment';
import { HeadBlock } from './components/HeadBlock';

type MaintenanceInfo = {
  from: string;
  to: string;
  description: string;
};

const Account: React.FC = () => {
  const [
    maintenanceInfo,
    setMaintenanceInfo,
  ] = useState<MaintenanceInfo | null>(null);
  useEffect(() => {
    async function fetchMaintenanceInfo() {
      const headers = {
        Accept: 'application/json',
      };
      const res = await fetch(
        `${env.appURL}/status/maintenance.json?t=${new Date().getTime()}`,
        {
          headers: headers,
          method: 'GET',
        }
      );

      if (res.status === 200) {
        setMaintenanceInfo((await res.json()) as MaintenanceInfo);
      }
    }
    fetchMaintenanceInfo();
  }, []);
  return (
    <>
      <HeadBlock />
      <div className="pt-20 px-8 h-full mx-auto bg-white">
        <img
          alt="みんかぶアセットプランナー"
          src="./static/images/minkabu_assetplanner.svg"
          width={240}
          className="mx-auto"
        />
        <div className="mt-8 text-center">
          <div className="text-xl font-bold">ただいまメンテナンス中です</div>
          <div className="mt-4 text-sm">
            {maintenanceInfo ? (
              <div className="text-red">
                メンテナンス時間
                <br />
                {maintenanceInfo.from} ～ {maintenanceInfo.to}
                <br />
                {maintenanceInfo.description}
              </div>
            ) : null}
            恐れ入りますが、しばらくしてからアクセスしてください。
          </div>
        </div>
      </div>
    </>
  );
};

export default Account;
